/**
 * CMCD Version 2
 *
 * @public
 */
export const CMCD_V2 = 2 as const
